import React, { useState, useEffect, useRef } from 'react';

import {
  validatePassword,
  allPasswordRules,
} from '../../../../utils/validation/passwordValidation';

import EditModalShell from '../forms/EditModalShell/EditModalShell';
import ErrorMessage from '../../../shared/ErrorMessage/ErrorMessage';
import ErrorMessages from '../../../shared/ErrorMessages/ErrorMessages';
import FormField from '../forms/FormField/FormField';

import './ChangePasswordModal.css';

const ChangePasswordModal = ({
  currentUser,
  onClose,
  onSubmit,
  errorMessage,
}) => {
  const initialFormState = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  const [formData, setFormData] = useState(initialFormState);
  const [modalPasswordErrorMessages, setModalPasswordErrorMessages] =
    useState(allPasswordRules);
  const { currentPassword, newPassword, confirmPassword } = formData;

  const firstInputRef = useRef();

  useEffect(() => {
    firstInputRef.current?.focus();
  }, []);

  const handleInputChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePasswordChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setModalPasswordErrorMessages(validatePassword(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <EditModalShell
      formId='change-password-modal-form'
      onClose={onClose}
      onSubmit={handleSubmit}
      title='Change Password'
      itemSublabel={currentUser?.userName}
      itemLabel='Password'
      isSubmitDisabled={modalPasswordErrorMessages.length > 0}
      className='change-password-modal-shell'
    >
      <ErrorMessage>{errorMessage}</ErrorMessage>
      <ErrorMessages
        errorsTitle='New password must have:'
        errors={allPasswordRules}
        currentErrors={modalPasswordErrorMessages}
      />

      <FormField
        type='password'
        name='currentPassword'
        label='Current Password'
        value={currentPassword}
        onChange={handleInputChange}
        ref={firstInputRef}
        required
      />
      <FormField
        type='password'
        name='newPassword'
        minLength={6}
        label='New Password'
        value={newPassword}
        onChange={handlePasswordChange}
        required
      />
      <FormField
        type='password'
        name='confirmPassword'
        label='Confirm Password'
        value={confirmPassword}
        onChange={handleInputChange}
        required
      />
    </EditModalShell>
  );
};

export default ChangePasswordModal;
